import { useMutation } from '@tanstack/react-query';
import { updateProfile } from '@/lib/api/settings';
import type { ProfileFormData } from '@/features/settings/validations/profile';
import { queryClient } from '@/queries';
import { QUERY_KEYS } from '@/lib/constants';

export const useProfile = () => {
    const { mutateAsync, isPending } = useMutation({
        mutationFn: (data: ProfileFormData) => updateProfile(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER] });
        },
    });

    return { mutateAsync, isPending };
};
